import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import MoreHoriz from '@material-ui/icons/MoreHoriz';
import Delete from '@material-ui/icons/Delete';
import CloudDownload from '@material-ui/icons/CloudDownload';
import intl from 'react-intl-universal';

import { formatFileSize, getFileIcon } from 'src/helpers/upload';
import Button from 'src/ui/library/Button';
import '@mdi/font/css/materialdesignicons.css';
import { ATTACHMENT_TYPES } from 'src/constants/constants';
import { fileRejectErrorType } from 'src/helpers/upload';

const components = {
  Delete,
  CloudDownload,
};
const getIcon = id => {
  const DynComp = components[id];

  return <DynComp className="icon sm" />;
};
const UploadViewPres = ({
  rejected,
  attachments,
  showMenu,
  showMenuHandler,
  menuHandler,
  menu,
  selectable,
  onSelected,
  showBorder,
  selectAction,
  deleteSelected,
  deleteEnabled,
  removeUnsupportedFile,
}) => {
  // short term fix till all attachments follow format:
  // {
  //   file: object,
  //   progress: number,
  // }
  let attachmentsWithProgress = attachments;
  if (attachments && attachments.length > 0) {
    //if a file is coming through and not just repopulating fields
    if (attachments[0].hasOwnProperty('file')) {
      attachmentsWithProgress = attachments.map(attachment => {
        if (typeof attachment.progress === 'undefined') {
          return { file: attachment, progress: 0 };
        }
        return attachment;
      });
    }
  }
  return (
    <Fragment>
      <div className="attach-container rejected">
        {rejected.map(file => (
          <div key={file.name} className="attach-file">
            <span className="file-button-container">
              <Button styleType="transparent-button" onClick={() => removeUnsupportedFile(file)}>
                {intl.get('default.label.okay')}
              </Button>
            </span>
            <span className={`mdi mdi-file file-icon`} />
            {file.name}
            <nav className="nav-bar">
              <span className="file-error">{intl.get('fileUploadError.' + fileRejectErrorType(file))}</span>
            </nav>
          </div>
        ))}
      </div>
      <div className="attach-container">
        {!!selectAction && attachmentsWithProgress && attachmentsWithProgress.length > 0 && (
          <span className={classNames('delete-attachment', { enabled: deleteEnabled })} onClick={deleteSelected}>
            {selectAction}
          </span>
        )}

        {attachmentsWithProgress &&
          attachmentsWithProgress.length > 0 &&
          attachmentsWithProgress.map(({ progress, file, name, size, filename, documentbody }, id) => {
            let nameOfFile = name || filename || '';
            let sizeOfAttachments = size;
            if (documentbody) {
              sizeOfAttachments = documentbody.length * (3 / 4) - 2;
            }
            let sizeOfFile = formatFileSize(sizeOfAttachments || 0);
            if (typeof file !== 'undefined') {
              nameOfFile = file.name || '';
              sizeOfFile = formatFileSize(file.size || 0);
            }
            return (
              <div className="attach-file" key={id}>
                {!!selectable && (
                  <span className="input-container">
                    <input type="checkbox" className="delete-input" onChange={onSelected.bind(this, id)} />
                  </span>
                )}
                <span className={`mdi ${getFileIcon(nameOfFile, ATTACHMENT_TYPES)} file-icon`} />
                {nameOfFile !== undefined && nameOfFile.substring(nameOfFile.lastIndexOf('\\') + 1)}
                <nav className="nav-bar">
                  <span className="file-size">{sizeOfFile}</span>
                  <nav className="menu-wrapper">
                    <MoreHoriz className="icon lg" onClick={() => showMenuHandler(id)} />
                    {showMenu[`menu${id}`] && (
                      <div className="menu-container">
                        <ul className="menu">
                          {menu &&
                            menu.map((item, j) => (
                              <li key={item.key ? item.key : item} className="menu-item" onClick={menuHandler.bind(this, j, id)}>
                                {getIcon(item.icon)}
                                {item.text}
                              </li>
                            ))}
                        </ul>
                      </div>
                    )}
                  </nav>
                  {showMenu[`menu${id}`] && <div className="screen" onClick={() => showMenuHandler(id)} />}
                </nav>
                <div className="upload-progress-bar" style={{ width: `${progress}%` }} />
              </div>
            );
          })}
      </div>
    </Fragment>
  );
};

UploadViewPres.propTypes = {
  attachments: PropTypes.array,
};

export default UploadViewPres;
